import { useParams, useNavigate } from "react-router-dom";
import { Switch, Tag, Button, Popconfirm } from "antd";
import dayjs from "dayjs";
import { routeToAddOrEdit, API_URL } from "../utils";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { IsEnable } from "../utils/enums";
import Modal from "../data/Modals";
import React, { useState } from "react";
import * as Components from "../components";
import noimage from "../assets/images/noimage.png";
import { owntoast } from "../utils";
import {
  OrderModalColumns,
  InvLogModalColumns,
  CountLogModalColumns,
  BuyingLogModalColumns,
  MoveLogModalColumns,
} from "../data/Columns";

const onChangeStatus = (e, value, row, form, request) => {
  if (form && form.url && form.method) {
    if (row.isenable === 1) row.isenable = 0;
    else row.isenable = 1;
    request({
      url: form.url,
      method: form.method,
      body: row,
      isfile: form.isFile,
    }).then((res) => {
      if (res.success) {
        owntoast(res.message, "success");
      } else {
        owntoast(res.message, "error");
        row.isenable = 1;
      }
    });
  }
};

const Formatter = ({
  value,
  format,
  page,
  index,
  row,
  form,
  request,
  isPrice,
  props,
}) => {
  const params = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(false);
  const navigate = useNavigate();
  const closeModal = () => {
    setIsOpen(false);
  };

  const getModalData = (type, request, value) => {
    if (type === "product") {
      request({
        url: `/order/seen/${value.id}`,
        method: "POST",
      }).then((res) => {
        if (res.success) {
          setData(value.details);
          setIsOpen(true);
        } else {
          owntoast(res.message, "error");
        }
      });
    } else if (type === "inv") {
      request({
        url: `/report/inventory/editlog/${value.storeid}/${value.productid}`,
      }).then((res) => {
        if (res.success) {
          setData(res.data);
          setIsOpen(true);
        } else {
          owntoast(res.message, "error");
        }
      });
    } else if (type === "buy") {
      request({
        url: `/product/buy/details/${value.id}`,
        method: "POST",
      }).then((res) => {
        if (res.success) {
          setData(res.data);
          setIsOpen(true);
        } else {
          owntoast(res.message, "error");
        }
      });
    }
  };

  const handleDelete = () => {
    if (props?._auth?.user?.id === 1) {
      let id = row?.id;
      let url = "/movement/delete";
      if (page.deleteurl) url = page.deleteurl;
      if (page.deleteparam) id = row[page.deleteparam];
      request({
        url: `${url}/${id}`,
        method: "DELETE",
      }).then((res) => {
        if (res.success) {
          owntoast(res.message, "success");

          if (page.url && page.model) {
            let searchValues = JSON.parse(
              localStorage.getItem(`search${page.url}`)
            );
            request({
              url: page.url,
              body: searchValues,
              method: "POST",
              model: page.model,
            });
          }
        }
      });
    } else {
      owntoast("Та энэ үйлдэлийг хийх эрхгүй байна", "error");
    }
  };

  if (format) {
    switch (format) {
      case "date":
        return value && dayjs(value).format("YYYY-MM-DD");
      case "datetime":
        return value && dayjs(value).format("YYYY-MM-DD HH:mm:ss");
      case "edit":
        return (
          <span
            /*  to={`/management/${params.id}/${params["*"]}/edit?index=${index}`} */
            className="text-blue cursor-pointer"
            onClick={() => {
              routeToAddOrEdit({ navigate, params, index, record: row });
              /*  localStorage.setItem("editRow", JSON.stringify(row)); */
            }}
          >
            Засах
          </span>
        );
      case "printcode":
        return (
          <span
            /*  to={`/management/${params.id}/${params["*"]}/edit?index=${index}`} */
            className="text-blue cursor-pointer"
          >
            Код хэвлэх
          </span>
        );
      case "status":
        return (
          <Switch
            size="small"
            checkedChildren={<CheckOutlined />}
            checked={value === 1}
            loading={row.loading}
            unCheckedChildren={<CloseOutlined />}
            className={value === 1 ? "bg-primary" : "bg-fullBack"}
            onChange={(e) => onChangeStatus(e, value, row, form, request)}
          />
        );
      case "img":
        if (value) {
          return (
            <div className="flex items-center justify-center">
              <img
                className="table-img h-10 w-10 rounded-md"
                src={`${API_URL}${value}`}
                onError={({ currentTarget }) => {
                  currentTarget.src = noimage;
                }}
              />
            </div>
          );
        } else {
          return <span>Зураггүй</span>;
        }
      case "statusexport":
        return value === IsEnable.Идэвхтэй ? "Идэвхтэй" : "Идэвхгүй";
      case "price":
        if (value)
          return new Intl.NumberFormat().format(Math.round(value * 100) / 100);
        return 0;
      case "linkPrice":
        return (
          <div className="underline cursor-pointer text-blue">
            {value ? new Intl.NumberFormat().format(value) : value}
          </div>
        );
      case "lowPrice":
        let tmpValue = value;
        if (isNaN(+value)) {
          tmpValue = value.replace("%", "");
        }
        if (tmpValue < 0) {
          return (
            <span className="text-red-500">
              {isPrice === false
                ? value
                : new Intl.NumberFormat().format(value)}
            </span>
          );
        } else {
          return isPrice === false ? value : Intl.NumberFormat().format(value);
        }
      case "See":
        if (value != null) {
          return (
            <div>
              <span
                onClick={() => getModalData("product", request, row)}
                className="text-blue cursor-pointer"
              >
                Харах
              </span>
              <Components.GlobalModal
                isOpen={isOpen}
                onClose={closeModal}
                title="Захиалсан бараанууд"
                width={600}
                footer={[
                  <Button
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  >
                    Хаах
                  </Button>,
                ]}
              >
                <Components.AntdTable
                  columns={OrderModalColumns}
                  dataSource={data}
                  pagination={false}
                  isModal={true}
                />
              </Components.GlobalModal>
            </div>
          );
        }
        return <a>baihgui</a>;
      case "SeeInv":
        return (
          <div>
            <span
              onClick={() => getModalData("inv", request, row)}
              className="text-blue cursor-pointer"
            >
              Харах
            </span>
            <Components.GlobalModal
              isOpen={isOpen}
              onClose={closeModal}
              title="Барааны нөөцийн өөрчлөлт"
              width={800}
              footer={[
                <Button
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  Хаах
                </Button>,
              ]}
            >
              <Components.AntdTable
                columns={InvLogModalColumns}
                dataSource={data}
                pagination={false}
                isModal={true}
              />
            </Components.GlobalModal>
          </div>
        );
      case "SeeCnt":
        return (
          <div>
            <span
              onClick={() => setIsOpen(true)}
              className="text-blue cursor-pointer"
            >
              Харах
            </span>
            <Components.GlobalModal
              isOpen={isOpen}
              onClose={closeModal}
              title="Тооллогын өөрчлөлт"
              width={800}
              footer={[
                <Button
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  Хаах
                </Button>,
              ]}
            >
              <Components.AntdTable
                columns={CountLogModalColumns}
                dataSource={row.details}
                pagination={false}
                isModal={true}
                isBranch={true}
              />
            </Components.GlobalModal>
          </div>
        );
      case "SeeBuy":
        return (
          <div>
            <span
              onClick={() => getModalData("buy", request, row)}
              className="text-blue cursor-pointer"
            >
              Харах
            </span>
            <Components.GlobalModal
              isOpen={isOpen}
              onClose={closeModal}
              title="Барааны татан авалтын задаргаа"
              width={800}
              footer={[
                <Button
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  Хаах
                </Button>,
              ]}
            >
              <Components.AntdTable
                columns={BuyingLogModalColumns}
                dataSource={data}
                pagination={false}
                isModal={true}
              />
            </Components.GlobalModal>
          </div>
        );
      case "SeeMove":
        return (
          <div>
            <span
              onClick={() => setIsOpen(true)}
              className="text-blue cursor-pointer"
            >
              Харах
            </span>
            <Components.GlobalModal
              isOpen={isOpen}
              onClose={closeModal}
              title="Хөдөлгөөн хийсэн бараанууд"
              width={800}
              footer={[
                <Button
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  Хаах
                </Button>,
              ]}
            >
              <Components.AntdTable
                columns={MoveLogModalColumns}
                dataSource={row.details}
                pagination={false}
                isModal={true}
              />
            </Components.GlobalModal>
          </div>
        );
      case "link":
        return (
          <div>
            <span
              onClick={() => setIsOpen(true)}
              style={{
                textDecoration: "underline",
                color: "blue",
                cursor: "pointer",
              }}
            >
              {new Intl.NumberFormat().format(value)}
            </span>
            <Modal
              type={"nonCash"}
              isOpen={isOpen}
              selectedRow={row}
              closeModal={closeModal}
            />
          </div>
        );
      case "role":
        if (value === 1) {
          return <span>Админ</span>;
        } else if (value === 2) {
          return <span>Касс</span>;
        } else if (value === 3) {
          return <span>Нягтлан</span>;
        }
        return null;
      case "paymentType":
        if (value === null) {
          return null;
        } else if (value === 1) {
          return <span>Бэлнээр</span>;
        } else if (value === 2) {
          return <span>Картаар</span>;
        } else if (value === 3) {
          return <span>Мобайлаар</span>;
        }else if (value === 4) {
          return <span>Зээл</span>;
        }
        break;
      case "salestatus":
        if (value === 1) {
          return <Tag color="green">Төлөгдсөн</Tag>;
        } else {
          return <Tag color="red">Төлөгдөөгүй</Tag>;
        }
      case "orderStatus":
        if (value === 1) {
          return <Tag color="blue">Үүсгэсэн</Tag>;
        } else if (value === 2) {
          return <Tag color="gray">Харсан</Tag>;
        } else if (value === 3) {
          return <Tag color="red">Зассан</Tag>;
        } else if (value === 4) {
          return <Tag color="yellow">Хүргэлтэнд гарсан</Tag>;
        } else {
          return <Tag color="green">Хүлээн авсан</Tag>;
        }
      case "onlyName":
        if (value) {
          return (
            <div>
              {value.map((item, i) => {
                return `${item.name}${value.length - 1 > i ? ", " : ""} `;
              })}
            </div>
          );
        }
        return null;
      case "saletype":
        if (value === 1) {
          return <Tag color="green">Борлуулалт</Tag>;
        } else {
          return <Tag color="red">Буцаалт</Tag>;
        }
      case "priceSaleType":
        return (
          <div
            className={`cursor-pointer ${
              row && row.type !== 1
                ? "text-red-600 underline"
                : "underline text-blue"
            }`}
          >
            {new Intl.NumberFormat().format(value ? value : 0)}
          </div>
        );
      case "clickable":
        return (
          <div className={`cursor-pointer underline text-blue`}>
            {new Intl.NumberFormat().format(value ? value : 0)}
          </div>
        );
      case "delete":
        return (
          <Popconfirm
            title={() => {
              return (
                <div className="flex flex-col">
                  <span>Устахдаа итгэлтэй байна уу?</span>
                </div>
              );
            }}
            placement="topLeft"
            onConfirm={handleDelete}
            okText="Тийм"
            loading={row.loading}
            cancelText="Үгүй"
          >
            <span className="text-red-600 cursor-pointer">Устгах</span>
          </Popconfirm>
        );
      case "print":
        return <span className="text-blue cursor-pointer">Хэвлэх</span>;
      default:
        return value;
    }
  }
  return value;
};

export default Formatter;
